import React from "react";
import ArrowLink from "../ArrowLink";
import styled from "styled-components";
import { H3, P } from "../typography";
import { HideTablet, HideDesktop } from "./Responsive";
import Pad from "../blocks/Pad";

const Section = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ theme, color }) => theme.colors[color]};
`;

const TextBox = styled.div`
  display: inline-block;
  padding: ${props => (props.padding ? "10rem 6.25rem" : "0")};
  max-width: 68rem;
  ${props => props.theme.media.mobile`
    padding: ${props.padding ? "10rem 1rem" : "0"};
  `} margin: auto;
  color: ${({ theme, fontColor }) => theme.colors[fontColor]};
`;

export default ({
  color = "transparent",
  fontColor = "dark",
  padding = true,
  titleText = "",
  bodyText = [""],
  link = null,
  align = "left",
  bold = true,
  join = false
}) => {
  const getFontColor = color =>
      color === "transparent" || color === "white" || color === "greyLight"
        ? "dark"
        : "white",
    derivedFontColor = fontColor || getFontColor(color),
    joinedText = join ? [bodyText.join(" ")] : bodyText;

  return (
    <Section color={color}>
      <TextBox fontColor={derivedFontColor} padding={padding}>
        <H3 serif weight={bold ? "bold" : "inherit"} align={align}>
          {titleText}
        </H3>
        <HideDesktop>
          {bodyText.map(line =>
            <P color={derivedFontColor} align={align}>
              {line}
            </P>
          )}
        </HideDesktop>
        <HideTablet>
          {joinedText.map(line =>
            <P color={derivedFontColor} align={align}>
              {line}
            </P>
          )}
        </HideTablet>
        {link &&
          <Pad v={0.75}>
            <ArrowLink color={link.color || "teal"} to={link.to}>
              <P color={link.color || "teal"} style={{ paddingBottom: 0 }}>
                {link.label}
              </P>
            </ArrowLink>
          </Pad>}
      </TextBox>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/components/blocks/ContentSection.js